<script>
  import { Router, Route } from "svelte-routing";

  // components for this layout
  import AdminNavbar from "components/Navbars/AdminNavbar.svelte";
  import Sidebar from "components/Sidebar/Sidebar.svelte";
  import HeaderStats from "components/Headers/HeaderStats.svelte";
  import FooterAdmin from "components/Footers/FooterAdmin.svelte";

  // pages for this layout
  import Dashboard from "views/admin/Dashboard.svelte";
  import Settings from "views/admin/Settings.svelte";
  import Tables from "views/admin/Tables.svelte";
  import Maps from "views/admin/Maps.svelte";
  import AssetMap from "../viewsERP/AssetMap.svelte";

  // Nonosky Quotations
  import Banco from "../views/admin/Banco.svelte";
  import Vendedor from "../views/admin/Vendedor.svelte";
  import Moneda from "../views/admin/Moneda.svelte";
  import Atributo from "../views/admin/Atributo.svelte";
  import Empresa from "../views/admin/Empresa.svelte";
  import Sucursal from "../views/admin/Sucursal.svelte";
  import Bodega from "../views/admin/Bodega.svelte";
  import Documento from "../views/admin/Documento.svelte";
  import Cliente from "../views/admin/Cliente.svelte";
  import Role from "../views/admin/Role.svelte";
  import Tipo from "../views/admin/Tipo.svelte";
  import Activo from "../views/admin/Activo.svelte";
  import Usuario from "../views/admin/Usuario.svelte";
  import ImpuestoPlantilla from "../views/admin/ImpuestoPlantilla.svelte";
  import Cobrador from "../views/admin/Cobrador.svelte";
  import Operador from "../views/admin/Operador.svelte";
  import CategoriaIva from "../views/admin/CategoriaIva.svelte";
  import Categoria from "../viewsERP/Categoria.svelte";
  import ProductoFiltros from "../viewsERP/ProductoFiltros.svelte";
  import ProductoNavegacion from "../viewsERP/ProductoNavegacion.svelte";
  import ProductoReportes from "../viewsERP/ProductoReportes.svelte";
  import Proyecto from "../views/admin/Proyecto.svelte";
  import Precio from "../views/admin/Precio.svelte";
  import Proveedor from "../views/admin/Proveedor.svelte";
  import Producto from "../views/admin/Producto.svelte";
  import Transporte from "../views/admin/Transporte.svelte";
  import Vehiculo from "../views/admin/Vehiculo.svelte";
  import Escolta from "../views/admin/Escolta.svelte";
  import Corredor from "../views/admin/Corredor.svelte";
  import RptActivo from "../viewsERP/RptActivo.svelte";
  
  // Nonosky Orders
  import Orders from "../viewsERP/Orders.svelte";
  import Quotation from "../viewsERP/Quotation.svelte";
  import CotizaDet from "../viewsERP/CotizaDet.svelte";

  export let location;
  export const admin = undefined; // Accept the admin prop to avoid the warning
</script>

<div>
  <Sidebar {location} />
  <div class="relative md:ml-64 bg-blueGray-100">
    <AdminNavbar />
    <HeaderStats />
    <div class="px-4 md:px-10 mx-auto w-full -m-24">
      <Router url="admin">
        <Route path="dashboard" component={Dashboard} />
        <Route path="settings" component={Settings} />
        <Route path="tables" component={Tables} />
        <Route path="maps" component={Maps} />
        <Route path="asset-map" component={AssetMap} />
        <Route path="banco/:id" component={Banco} />
        <Route path="vendedor/:id" component={Vendedor} />
        <Route path="moneda/:id" component={Moneda} />
        <Route path="atributo" component={Atributo} />
        <Route path="atributo/:id" component={Atributo} />
        <Route path="empresa/:id" component={Empresa} />
        <Route path="sucursal/:id" component={Sucursal} />
        <Route path="bodega/:id" component={Bodega} />
        <Route path="documento/:id" component={Documento} />
        <Route path="cliente/:id" component={Cliente} />
        <Route path="role/:id" component={Role} />
        <Route path="tipo/:id" component={Tipo} />
        <Route path="activo/:id" component={Activo} />
        <Route path="usuario/:id" component={Usuario} />
        <Route path="impuestoPlantilla/:id" component={ImpuestoPlantilla} />
        <Route path="cobrador/:id" component={Cobrador} />
        <Route path="operador/:id" component={Operador} />
        <Route path="categoriaIva/:id" component={CategoriaIva} />
        <Route path="categoria/:id" component={Categoria} />
        <Route path="producto-filtros" component={ProductoFiltros} />
        <Route path="producto-navegacion" component={ProductoNavegacion} />
        <Route path="producto-reportes" component={ProductoReportes} />
        <Route path="proyecto/:id" component={Proyecto} />
        <Route path="precio/:id" component={Precio} />
        <Route path="proveedor/:id" component={Proveedor} />
        <Route path="producto/:id" component={Producto} />
        <Route path="transporte/:id" component={Transporte} />
        <Route path="vehiculo/:id" component={Vehiculo} />
        <Route path="escolta/:id" component={Escolta} />
        <Route path="corredor/:id" component={Corredor} />
        <Route path="rpt-activo/:id" component={RptActivo} />
        
        <!-- Nonosky Orders Routes -->
        <Route path="orders" component={Orders} />
        <Route path="cotizacion/:id?" component={Quotation} />
        <Route path="cotizacion-detalles/:id" component={CotizaDet} />
      </Router>
      <FooterAdmin />
    </div>
  </div>
</div>
